import { config } from "./config.js";

export function setupGA() {
  if (!config.gaId) return;

  // 1. 確保 dataLayer 存在 (但不要自行初始化，讓 GA 腳本處理)
  // 如果網站沒 GA，dataLayer 也不會在 window 上，此時需要手動建立一個空陣列。
  window.dataLayer = window.dataLayer || [];

  // 2. 載入 gtag.js (如果網站還沒載入)
  if (!window.dcGtag) {
    const s = document.createElement("script");
    s.src = `https://www.googletagmanager.com/gtag/js?id=${config.gaId}`;
    s.async = true;
    document.head.appendChild(s);
  }

  // 3. 確保 gtag 函式可用 (如果網站還沒載入，這會是個暫時的替身)
  // 讓您的 SDK 程式碼可以安全地呼叫 gtag
  if (!window.dcGtag) {
      window.dcGtag = function() { window.dataLayer.push(arguments); };
  }

  // 4. 配置您專屬的 GA ID
  window.dcGtag("js", new Date());
  window.dcGtag("config", config.gaId, { send_page_view: false });
}

// sendGA 函數調整
export function sendGA(eventName, params) {
  if (!config.gaId) return;
  console.log("GA Event:", eventName, params);

  // 由於 setupGA 已經確保 window.dcGtag 存在，我們可以安全地呼叫它
  if (window.dcGtag) {
    // 關鍵：使用 send_to 確保事件只發送到您的專屬 ID
    window.dcGtag('event', eventName, {
      ...params,
      // *** 確保事件只發送到您 SDK 的 Measurement ID
      'send_to': config.gaId
    });
  }
}
